import { j as p } from "./jsx-runtime-944c88e2.js";
import * as t from "react";
import { p as n } from "./index-efd35e77.js";
import { v as k, c as v, p as y } from "./package-metadata-112a2384.js";
import "./index-64063129.js";
var o = t.forwardRef(function(e, i) {
  k(y);
  var c = e.className, u = e.style, s = t.useRef(null), m = t.useCallback(function() {
    s.current && s.current.focus();
  }, []);
  t.useImperativeHandle(i, function() {
    return {
      element: s.current,
      focus: m
    };
  });
  var r = t.useMemo(function() {
    return e.shape || l.shape;
  }, [e.shape]), a = t.useMemo(function() {
    return e.animation === !1 ? !1 : e.animation || l.animation;
  }, [e.animation]), f = t.useMemo(function() {
    return v("k-skeleton", {
      "k-skeleton-circle": r === "circle",
      "k-skeleton-rect": r === "rectangle",
      "k-skeleton-text": r === "text",
      "k-skeleton-pulse": typeof a == "object" && a.type === "pulse",
      "k-skeleton-wave": typeof a == "object" && a.type === "wave" || a === !0
    }, c);
  }, [r, a, c]);
  return t.createElement("span", { ref: s, className: f, style: u });
});
o.propTypes = {
  className: n.string,
  style: n.object,
  animation: n.shape({
    type: n.oneOf(["wave", "pulse"])
  }),
  shape: n.oneOf(["circle", "rectangle", "text"])
};
var l = {
  shape: "text",
  animation: { type: "pulse" }
};
o.defaultProps = l;
o.displayName = "KendoSkeleton";
const N = (e) => /* @__PURE__ */ p.jsx(o, { ...e });
export {
  N as Skeleton
};
